export default __webpack_public_path__ + "_/shared_modules/common-images/green-circle-check-064408e206efe43f02a47953722e671a.svg";